const Modal = ({ children, show }) => {
  return (
    <div
      className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5 ${
        show ? 'show' : 'hidden'
      }`}
      style={{ zIndex: 1000 }}
    >
      {children}
    </div>
  );
};

export default Modal;
